<div class="error-panel" #errorComponentParentElement>
	<h4 style="font-size: large;">The following integrated system is unavailable:</h4>
	<div *ngFor="let errorData of this.errorArray | keyvalue">
		<div style="font-size: large;" *ngIf="errorData.key !== 'undefined'">{{ errorData.key }}</div>
		<br>
		<div *ngFor="let error of errorData.value">
			<span style="font-size: large;">{{ error?.statusCode }} - {{ error?.errorMessage }}</span>
		</div>
		<br>
	</div>		
	<p>
		Please try again later. If the problem persists, please
		<a routerLink="contactUs" target="_blank">contact us</a>
	</p>
    <button mat-button style="background-color: white;" (click)="onClickDismiss()" >Dismiss</button>
</div>